import {Controller} from "stimulus"
import noUiSlider from 'nouislider/distribute/nouislider.min'
import wNumb from 'wnumb/wNumb.min'

export default class extends Controller {
  static targets = [
    'slider',
    'bags',
    // 'seals',
    'container',
  ]

  connect() {
    noUiSlider.create(this.sliderTarget, {
      connect: 'lower',
      start: this.data.get('default'),
      range: {
        min: 0,
        max: 500
      },
      step: 10,
      orientation: 'horizontal',

      tooltips: true,
      format: wNumb({
        decimals: 0,
      })

    })

    this.sliderTarget.noUiSlider.on('change', (values, handle) => {
      if (values[handle] < 30) {
        this.sliderTarget.noUiSlider.set(30)
      }
    })

    this.sliderTarget.noUiSlider.on('update', (values) => {
      // this.calculateSeals()
      this.bagsTarget.value = values[0]

      if ("createEvent" in document) {
        let evt = document.createEvent("HTMLEvents")
        evt.initEvent("change", false, true)
        this.bagsTarget.dispatchEvent(evt)
      } else {
        this.bagsTarget.fireEvent("onchange")
      }
    })
  }

  disconnect() {
    this.sliderTarget.noUiSlider.destroy()
  }
}
